import { createInternalFeatureLoader } from '@/utils/feature-loading-util'
import type { Observable } from 'rxjs'
import type { GetCurrentMemberFn } from '@/features/iam'
import type {
  SnackbarFactory,
  SnackbarRetryWrapperFactory,
} from '@/features/shell'
import type {
  BookkeepingPlatformSelectionDialogViewModel,
  BookkeepingPlatformSelectionDialogViewModelOptions,
} from '@/features/bookkeeping/components/BookkeepingPlatformSelectionDialog/BookkeepingPlatformSelectionDialogViewModel'

/**
 * Options for the {@link BookkeepingFeature}.
 */
export interface BookkeepingFeatureOptions {
  token$: Observable<string>
  createSnackbarRetryWrapper: SnackbarRetryWrapperFactory
  getCurrentMember: GetCurrentMemberFn
  newSnackbar: SnackbarFactory
}

/**
 * Factory for creating a BookkeepingPlatformSelectionDialogViewModel based on the options.
 */
export type BookkeepingPlatformSelectionDialogViewModelFactory = (
  vmOptions: BookkeepingPlatformSelectionDialogViewModelOptions,
) => BookkeepingPlatformSelectionDialogViewModel

/**
 * Everything related to bookkeeping.
 */
export type BookkeepingFeature = ReturnType<typeof BookkeepingFeature>

export function BookkeepingFeature(options: BookkeepingFeatureOptions) {
  const internal = createInternalFeatureLoader(
    () => import('./internal'),
    (module) => module.InternalBookkeepingFeature(options),
  )

  return {
    // Internal
    internal,

    // Public
    createBookkeepingPlatformSelectionDialogViewModel: internal.lazy(
      (m) => m.createBookkeepingPlatformSelectionDialogViewModel,
    ),
  }
}
